import { WrappedPair } from '@/entities/WrappedPair';
import { WrappedRange } from '@/entities/WrappedRange';
import { useWrappedRangeListByUser } from '@/features/account/rangeHook';
import { useTradeStore } from '@/features/trade/store';
import { useChainId, useUserAddr } from '@/hooks/web3/useChain';
import { useMemo } from 'react';

/**
 * Hook to get and filter liquidities based on hideOtherPair setting
 * @param currentPair - Current trading pair
 * @returns Filtered array of liquidities
 */
export const useFilteredLiquidities = (currentPair: WrappedPair | undefined, isTradePage = true): WrappedRange[] => {
  const chainId = useChainId();
  const userAddr = useUserAddr();
  const { hideOtherPair } = useTradeStore();
  const liquidities = useWrappedRangeListByUser(chainId, userAddr, false);

  return useMemo(() => {
    if (!liquidities) {
      return [];
    }
    if (!hideOtherPair || !currentPair || !isTradePage) {
      return liquidities;
    }
    return liquidities.filter((range) => range.rootPair?.id === currentPair.id);
  }, [liquidities, hideOtherPair, currentPair, isTradePage]);
};
